var map = {
	"./apw/apw.png": "4a15",
	"./aus-super/aus-super.png": "7de2",
	"./axiell-alm/axiell-alm.png": "c934",
	"./bmw-engage/bmw-engage.png": "c63b",
	"./bmw-full-circle/bmw-full-circle.png": "100b",
	"./caresuper/caresuper.png": "f279",
	"./global-kinetics/global-kinetics.png": "d1c1",
	"./isuzu-bmt/isuzu-bmt.png": "e6ed",
	"./micf/micf.png": "6b00",
	"./rasv/rasv.png": "ef65",
	"./royal-show/royal-show.png": "7c2b",
	"./sw-tafe/sw-tafe.png": "8b2f",
	"./vamff/vamff.png": "b52e",
	"./vic-gov/vic-gov.png": "6dd4",
	"./vu-centenary/vu-centenary.png": "2f2c",
	"./white-night/white-night.png": "285d",
	"./winning-tastes/winning-tastes.png": "d1c4",
	"./zoos-vic/zoos-vic.png": "8417"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bd1";